const tableTitleUser = {
  title: 'Users',
  placeholder: 'Search'
};

export default tableTitleUser;
